import { TabStyles } from '@tableau/widgets';
import * as React from 'react';
import { divWithStyle } from '../../style/LayoutComponents';
import { elideTextStyle } from '../../style/LayoutStyles';
import { cellPaddingStyle } from './CellStyles';

const PlaceholderTextCellContainer = divWithStyle('PlaceholderTextCell', [elideTextStyle, cellPaddingStyle, {
  fontStyle: 'italic',
  color: TabStyles.Typography.Color.Secondary,
}]);

const noPadding: React.CSSProperties = {
  paddingLeft: 0
};

interface PlaceholderTextCellProps {
  readonly placeholderText: string;
  readonly noPadding?: boolean;
}

export function PlaceholderTextCell(props: PlaceholderTextCellProps) {
  return (
    <PlaceholderTextCellContainer title={props.placeholderText} style={props.noPadding ? noPadding : undefined}>
      {props.placeholderText}
    </PlaceholderTextCellContainer>
  );
}
